import React, { useState } from 'react'

import {
  buildAutocompleteQueryConfig,
  buildFacetConfigFromConfig,
  buildSearchOptionsFromConfig,
  getConfig,
} from "../../config/config-helper";

import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import { SearchProvider, SearchBox } from '@elastic/react-search-ui';
//import SearchBox from '@elastic/react-search-ui-views/lib/SearchBox';
import  Navigation from '../components/NavigationCheck';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});
const config = {
  searchQuery: {
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true
};

export const ElasticForm = ({match,isInicio = false}) => {
    let history = useHistory();
    const [checkState, setCheckState] = useState({
        centro:false,
        investigador:true
    })

    const navigate=(useCase, query) => {
        //to know if the component is on inicio or not 
        if(isInicio)
        {
          if(useCase.centro)
          {
            history.push(`${match.url}centro/?q=+${query}`);
          } else
            {
              history.push(`${match.url}investigador/?q=+${query}`)
            }
        } else {
          //if the componets isnt on init we need to use it in a funtional way
          //history.push(`/?q='+${query}`);
          //search by elastic
        }
      }

/*     useEffect(() => {
        navigate(checkState)
    }, [checkState]) */
    return (
        <div>
            <SearchProvider config={ config }>
              <SearchBox 
                inputProps={ !isInicio ? { placeholder: "Búsqueda de Investigadores" } : { placeholder: 'Escribir acá palabras claves' }}
                onSubmit={ (e) => { navigate(checkState,e) }}
              />

              <Grid
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
              >
                <br/>
                <Navigation state={checkState} setBusqueda={setCheckState}/>
              </Grid>
            </SearchProvider>
{/*             <SearchProvider config={config}  >
                <WithSearch mapContextToProps={({ wasSearched, setSearchTerm }) => ({ wasSearched, setSearchTerm })}>
                    {({ wasSearched, setSearchTerm }) => {
                    return (
                        <div className="App">
                            <ErrorBoundary>
                                <Layout
                                sideContent={
                                    <div>
                                    {wasSearched && (
                                        <Sorting
                                        label={"Sort by"}
                                        sortOptions={buildSortOptionsFromConfig()}
                                        />
                                    )}
                                    {getFacetFields().map(field => (
                                        <Facet key={field} field={field} label={field} />
                                    ))}
                                    </div>
                                }
                                />
                            </ErrorBoundary>
                        </div>
                    );
                    }}
                </WithSearch>
            </SearchProvider> */}
        </div>
    )
}
